<script>
    import { checkSession_getSelf } from "../lib/api";
    import { onMount } from "svelte";

    import Holiday from "./Holiday.svelte";

    /** @import {AuthVars} from "../lib/api" */

    /** @type {AuthVars} */
    let authVars = $state();
    let selectedTab = $state("holiday")


    onMount(async ()=>{
        authVars = await checkSession_getSelf();
    });
</script>

<header>
    <a href="/home" id="home-button">
        <img class="icon" src="/www/favicon.png" alt="Letas Icon" />
        <span>{authVars?.user?.name ?? ""}</span>
    </a>
    <div style="flex-grow: 1;"></div>
    <label class="tab">
        Vacances
        <input type="radio" name="tab" value="holiday" bind:group={selectedTab} checked />
    </label>
</header>

{#if authVars}
    {#if selectedTab == "holiday"}
        <Holiday authVars={authVars} />
    {/if}
{/if}
